<template>
  <div id="container" style="position: relative">
    <div class="title">数字孪生三维可视化</div>
    <div id="container-select">
      <dv-border-box-8 :style="{ width: '305px', height: '50px' }">
        <el-cascader
          v-model="addressValue"
          class="cascader"
          placeholder="请选择船舶"
          :options="companyList"
          :show-all-levels="false"
          :append-to-body="false"
          :props="{
            expandTrigger: 'hover',
          }"
          filterable
          @change="handleChange"
        />
      </dv-border-box-8>
    </div>
    <div class="left">
      <div id="container-left">
        <div class="big-content">
          <div class="title_Top" style="margin-top: 40px">数字仪表盘</div>
          <div
            style="
              width: 100%;
              height: 90%;
              background-color: rgba(0, 0, 0, 0.3);
              display: flex;
            "
          >
            <div style="flex: 1">
              <div ref="showPieOne" style="height: 100%"></div>
              <div
                style="
                  text-align: center;
                  margin-top: -30px;
                  font-weight: 700;
                  color: #429bf7;
                "
              >
                0
              </div>
            </div>
            <div style="flex: 1">
              <div ref="showPieTwo" style="height: 100%"></div>
              <div
                style="
                  text-align: center;
                  margin-top: -30px;
                  font-weight: 700;
                  color: #4fec7b;
                "
              >
                {{ speed }}km/h
              </div>
            </div>
          </div>
        </div>
        <div class="big-content">
          <div class="title_Top" style="margin-top: 20px">船舶吃水</div>

          <div
            ref="showLine"
            style="
              width: 100%;
              height: 90%;
              margin-top: 3px;
              background-color: rgba(0, 0, 0, 0.3);
            "
          ></div>
        </div>
        <div class="big-content">
          <div class="title_Top" style="margin-top: 20px">船舶倾角</div>
          <div
            style="
              width: 100%;
              height: 90%;
              background-color: rgba(0, 0, 0, 0.3);
              display: flex;
            "
          >
            <div style="flex: 1">
              <div ref="showAngleOne" style="height: 100%"></div>
            </div>
            <div style="flex: 1">
              <div ref="showAngleTwo" style="height: 100%"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right">
      <div id="container-right">
        <div class="big-content">
          <div class="title_Top" style="margin-top: 40px">船舶概况</div>
          <div
            style="
              width: 100%;
              height: 90%;
              padding: 5px 10px;
              margin-top: 3px;
              overflow: auto;
              background-color: rgba(0, 0, 0, 0.3);
            "
          >
            <div class="item_box" style="height: 100%">
              <div
                style="
                  height: 20%;
                  margin-bottom: 10px;
                  padding: 5px 0;
                  border-bottom: 1px solid #00bbf2;
                "
              >
                <img
                  src="@/assets/images/ship2.png"
                  alt=""
                  width="20px"
                  height="20px"
                  style="margin-bottom: -3px; margin-right: 5px"
                />
                <span>{{ shipInfo.shipName }}</span>
                <span style="color: #04b1e9; margin-left: 45px">
                  当前状态：
                  <span style="color: #fff" v-if="shipInfo.speed">{{
                    shipInfo.speed > 0.5 ? "航行中" : "停泊"
                  }}</span></span
                >
              </div>
              <div style="height: 30%; border-bottom: 1px solid #00bbf2">
                <div>
                  <span style="color: #04b1e9">MMSI号：</span
                  >{{ shipInfo.mmsi }}
                </div>
                <div style="margin-top: 10px">
                  <span style="color: #04b1e9">CN号：</span
                  >{{ shipInfo.shipId }}
                </div>
              </div>
              <!-- <div
                  style="
                    margin-bottom: 10px;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  <div>
                    <img
                      src="@/assets/images/constructor.png"
                      alt=""
                      width="20px"
                      height="20px"
                      style="margin-bottom: -3px; margin-right: 5px"
                    />
                    <span style="color: #04b1e9">配员：</span>110
                  </div>
                  <button
                    style="
                      background-color: #04b1e9;
                      color: #fff;
                      cursor: pointer;
                      border: none;
                      padding: 0 5px;
                    "
                  >
                    更多
                  </button>
                </div>
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 10px;
                    border-bottom: 1px solid #00bbf2;
                    padding-bottom: 5px;
                  "
                >
                  <div class="center">
                    <div>71</div>
                    <div style="color: #04b1e9">船长</div>
                  </div>
                  <div class="center">
                    <div>71</div>
                    <div style="color: #04b1e9">大副</div>
                  </div>
                  <div class="center">
                    <div>71</div>
                    <div style="color: #04b1e9">轮机长</div>
                  </div>
                </div> -->
              <div>
                <div
                  style="
                    margin-bottom: 10px;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  <div style="margin: 10px 0">
                    <img
                      src="@/assets/images/info.png"
                      alt=""
                      width="20px"
                      height="20px"
                      style="margin-bottom: -3px; margin-right: 5px"
                    />
                    <span style="color: #04b1e9">技术状况</span>
                  </div>
                </div>
                <div style="display: flex; justify-content: space-around">
                  <div class="center">
                    <div>{{ shipInfo.displacement || 0 }}</div>
                    <div style="color: #04b1e9">排水量</div>
                  </div>
                  <div class="center">
                    <div>{{ shipInfo.breadth || 0 }}</div>
                    <div style="color: #04b1e9">型宽</div>
                  </div>
                  <div class="center">
                    <div>{{ shipInfo.deep || 0 }}</div>
                    <div style="color: #04b1e9">型深</div>
                  </div>
                  <div class="center">
                    <div>{{ shipInfo.length || 0 }}</div>
                    <div style="color: #04b1e9">型长</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="big-content">
          <div class="title_Top" style="margin-top: 20px">油舱液位</div>
          <div
            ref="showPower"
            style="
              width: 100%;
              height: 90%;
              padding-top: 10px;
              margin-top: 3px;
              background-color: rgba(0, 0, 0, 0.3);
            "
          ></div>
        </div>
        <div class="big-content">
          <div class="title_Top" style="margin-top: 20px">转速</div>
          <div
            style="
              width: 100%;
              height: 90%;
              background-color: rgba(0, 0, 0, 0.3);
              display: flex;
            "
          >
            <div style="flex: 1">
              <div ref="showLeft" style="height: 100%"></div>
              <div
                style="
                  text-align: center;
                  margin-top: -30px;
                  font-weight: 700;
                  color: #429bf7;
                "
              >
                {{ artotlm }}
              </div>
            </div>
            <div style="flex: 1">
              <div ref="showRight" style="height: 100%"></div>
              <div
                style="
                  text-align: center;
                  margin-top: -30px;
                  font-weight: 700;
                  color: #4fec7b;
                "
              >
                {{ artotrm }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="container-centerRight">
      <div class="title_Top" style="margin-top: 30px">动态信息</div>
      <div
        style="
          width: 200px;
          height: 90px;
          padding: 10px 0 0 10px;
          background-color: rgba(0, 0, 0, 0.3);
        "
      >
        <div style="color: #04b1e9; margin-bottom: 20px">
          天气：<span style="color: #fff"
            >{{ text }} {{ windDir }} {{ temp }}°C</span
          >
        </div>
        <div style="color: #04b1e9">
          所在水道：<span style="color: #fff">{{ shipInfo.waterway }}</span>
        </div>
      </div>
    </div>

    <div id="container-centerLeft">
      <div class="title_Top" style="margin-top: 30px">设备运行状态</div>
      <div
        style="
          width: 300px;
          height: 80px;
          padding: 10px 0 0 10px;
          background-color: rgba(0, 0, 0, 0.3);
        "
      >
        <div style="display: flex; justify-content: space-around">
          <div class="center" style="color: #64b28a">
            <div style="font-size: 25; font-weight: 800">75732</div>
            <div>在线</div>
          </div>
          <div class="center" style="color: #688aa6">
            <div style="font-size: 25; font-weight: 800">12</div>
            <div>离线</div>
          </div>
          <div class="center" style="color: #d6ddbb">
            <div style="font-size: 25';font-weight: 800">23</div>
            <div>故障</div>
          </div>
          <div class="center" style="color: #c67281">
            <div style="font-size: 25; font-weight: 800">3781</div>
            <div>告警</div>
          </div>
        </div>
      </div>
    </div>

    <div id="container-centerBottom">
      <div class="title_Top">设备运行情况</div>
      <div class="box-container">
        <div class="box" v-for="(item, index) in deviceList" :key="index">
          <div class="device_title">{{ item.name }}</div>
          <div class="device_info">
            <div class="device_top">{{ item.value }}{{ item.unit }}</div>
            <div class="device_time">{{ currentTime | getTime }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as THREE from "three";
import * as echarts from "echarts";
import axios from "axios";
import "echarts-liquidfill";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { Water } from "three/examples/jsm/objects/Water.js";
import { Sky } from "three/examples/jsm/objects/Sky";
import { FBXLoader } from "three/examples/jsm/loaders/FBXLoader.js";
import { processShipData } from "../utils/mapping.js";
let scene;
export default {
  data() {
    return {
      token: "Bearer ",
      // 请求地址前缀
      BASE_URL: "/api",
      // BASE_URL: 'http://192.168.31.38:2023',
      camera: null,
      water: undefined,
      currentTime: new Date(),
      PieOneData: [
        //当前数值的数据
        {
          name: "左机转速",
          value: 0,
        },
      ],
      PieTwoData: [
        //当前数值的数据
        {
          name: "右机转速",
          value: 0,
        },
      ],
      oil: 0, //油耗,
      speed: 0, //船速
      powerData: [
        {
          value: 0,
          name: "左油舱液位",
        },
        {
          value: 0,
          name: "右油舱液位",
        },
        {
          value: 0,
          name: "左油柜液位",
        },

        {
          value: 0,
          name: "右油柜液位",
        },
      ],
      artotlm: 0,
      artotrm: 0,
      sia: 0,
      lariaots: 0,
      // 吃水数据
      waterData: [0],
      // 船列表数据
      companyList: [],
      // 底部列表
      deviceList: [],
      shipName: "",
      userInfo: {},
      addressValue: "",
      temp: "", //温度
      text: "", // 天气状况
      windDir: "", //风向
      windScale: "", //风速,
      shipInfo: {}, //船舶基础数据
    };
  },
  filters: {
    getTime(d) {
      return (
        d.getFullYear() +
        "-" +
        (d.getMonth() + 1) +
        "-" +
        d.getDate() +
        " " +
        d.getHours() +
        ":" +
        d.getMinutes() +
        ":" +
        d.getSeconds()
      );
      // const localDate = new Date(
      //   date.getTime() - date.getTimezoneOffset() * 60000
      // );
      // return localDate.toISOString().replace("T", " ").slice(0, 19);
    },
  },
  methods: {
    initScene() {
      scene = new THREE.Scene();
      this.initLights();
    },
    initLights() {
      const ambientLight = new THREE.AmbientLight(0x808080, 1); // 环境光
      scene.add(ambientLight);

      const directionalLight = new THREE.DirectionalLight(0xffffff, 2); // 方向光
      directionalLight.position.set(200, 200, 200).normalize();
      directionalLight.intensity = 2;
      scene.add(directionalLight);
    },
    initCamera() {
      // this.camera = new THREE.PerspectiveCamera(
      //   45,
      //   window.innerWidth / window.innerHeight,
      //   0.1,
      //   10000
      // );
      // this.camera.position.set(0, 100, 100);
      this.camera = new THREE.PerspectiveCamera(
        45,
        window.innerWidth / window.innerHeight,
        1,
        10000
      );
      this.camera.position.set(20, 20, 100);
    },
    initRenderer() {
      this.renderer = new THREE.WebGLRenderer({ antialias: true });
      this.container = document.getElementById("container");
      this.renderer.setSize(
        this.container.clientWidth,
        this.container.clientHeight
      );
      this.renderer.setClearColor("#294f9a", 1.0);
      this.container.appendChild(this.renderer.domElement);
    },
    initControl() {
      this.controls = new OrbitControls(this.camera, this.renderer.domElement);
      this.controls.enableDamping = true;
      this.controls.maxPolarAngle = Math.PI / 2.2;
    },
    initSky() {
      let sky = new Sky();
      sky.scale.setScalar(45000); //太阳盒子的大小，要把整个场景包含进去
      scene.add(sky);

      const effectController = {
        turbidity: 5, //浑浊度
        rayleigh: 2, //阳光散射，黄昏效果的程度
        mieCoefficient: 0.005, //太阳对比度，清晰度
        mieDirectionalG: 0.7,
        elevation: 2, //太阳高度
        azimuth: 180, //太阳水平方向位置
        exposure: this.renderer.toneMappingExposure, //光线昏暗程度
      };

      let sun = new THREE.Vector3();
      const uniforms = sky.material.uniforms;
      uniforms["turbidity"].value = effectController.turbidity;
      uniforms["rayleigh"].value = effectController.rayleigh;
      uniforms["mieCoefficient"].value = effectController.mieCoefficient;
      uniforms["mieDirectionalG"].value = effectController.mieDirectionalG;
      const phi = THREE.MathUtils.degToRad(90 - effectController.elevation);
      const theta = THREE.MathUtils.degToRad(effectController.azimuth);
      sun.setFromSphericalCoords(1, phi, theta);
      uniforms["sunPosition"].value.copy(sun);
      this.renderer.toneMappingExposure = effectController.exposure;
      this.renderer.render(scene, this.camera);
    },
    initWater() {
      const waterGeometry = new THREE.PlaneGeometry(10000, 10000);
      this.water = new Water(waterGeometry, {
        textureWidth: 512,
        textureHeight: 512,
        waterNormals: new THREE.TextureLoader().load(
          require("../assets/images/waternormals.jpg"),
          function (texture) {
            texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
          }
        ),
        sunDirection: new THREE.Vector3(),
        alpha: 1.0,
        sunColor: 0xffffff,
        waterColor: 0x294f9a,
        distortionScale: 3.7,
      });
      this.water.rotation.x = -Math.PI / 2;
      scene.add(this.water);
    },
    initAnimate() {
      this.water.material.uniforms["time"].value += 1.0 / 60.0;
      requestAnimationFrame(this.initAnimate);
      this.renderer.render(scene, this.camera);
    },
    loadFBXModel() {
      const loader = new FBXLoader();
      loader.load("/statics/model/ship.fbx", function (object) {
        object.traverse(function (child) {
          if (child.isMesh) {
            child.material.doubleSided = true;
            child.material.side = THREE.DoubleSide;
            child.material.emissiveIntensity = 1;
            child.material.emissive = new THREE.Color(0.1, 0.1, 0.1);
            child.material.emissiveMap = child.material.map;
          }
        });
        scene.add(object);
      });
    },
    initPage() {
      this.initScene();
      this.initCamera();
      this.initRenderer();
      this.initControl();
      this.initWater();
      this.initAnimate();
      this.loadFBXModel();
    },

    onWindowResize() {
      this.camera.aspect = window.innerWidth / window.innerHeight;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize(window.innerWidth, window.innerHeight);
    },

    getCompanyList() {
      axios({
        url: this.$root.BASE_URL + "/system/user/profile",
        method: "get",
        headers: {
          authorization: this.token,
        },
      }).then((res) => {
        this.userInfo = res.data.data;
        // 查询公司-船舶/码头-摄像头信息
        this.getList();
      });
    },
    getList() {
      let data = {
        roleId: this.userInfo.roles[0].roleId,
        userId: this.userInfo.userId,
        deptId: this.userInfo.deptId,
      };
      axios({
        url: this.$root.BASE_URL + "/work/sy/company/list",
        method: "post",
        data,
        headers: {
          authorization: this.token,
        },
      }).then((res) => {
        this.companyList = res.data.data;
        let list = [];
        list = res.data.data.map((item) => {
          let newItem = JSON.parse(JSON.stringify(item));
          if (newItem.children && Array.isArray(newItem.children)) {
            newItem.children = newItem.children.map((child) => {
              if (child.children) {
                delete child.children;
              }
              return child;
            });
          }
          return newItem;
        });
        this.companyList = list;
      });
    },

    handleChange(e) {
      console.log(e, "eeeeeeeeeeeeeeeeeeee");
      // 船舶识别号
      let shipId = e[1];
      if (e[1] == "RY20230912001") {
        shipId = "CN20230347772";
      }
      this.rest();
      this.digitalShipInfo(shipId);
      axios({
        url: this.$root.BASE_URL + `/work/ship_info/status?shipId=${shipId}`,
        // url: this.$root.BASE_URL + `/work/ship_info/status?shipId=CN20230347772`,
        method: "get",
        headers: {
          authorization: this.token,
        },
      }).then((res) => {
        if (res.data.data) {
          this.deviceList = processShipData(res.data.data);

          // 数字仪表盘
          this.speed = res.data.data.speed || 0;
          this.showPieChart();
          // 左中
          let { ldatsots, sad, rdatsots } = res.data.data;
          this.waterData = [ldatsots || 0, sad || 0, rdatsots || 0];
          this.showLineChart();
          // 左下
          this.lariaots = res.data.data.lariaots || 0;
          this.sia = res.data.data.sia || 0;
          this.showAngleChart();
          // 右中
          this.powerData[0].value = res.data.data.lotl || 0;
          this.powerData[1].value = res.data.data.rlotl || 0;
          this.powerData[2].value = res.data.data.lotll || 0;
          this.powerData[3].value = res.data.data.rlotll || 0;
          this.showPowerChart();
          // 右下
          this.PieOneData[0].value = res.data.data.les || 0;
          this.PieTwoData[0].value = res.data.data.res || 0;
          this.artotlm = res.data.data.artotlm || 0;
          this.artotrm = res.data.data.artotrm || 0;
          this.showRihtChart();
        }
        console.log(res, "resres");
      });
    },
    // 切换重置数据
    rest() {
      // 重置数据
      this.deviceList = [];
      this.speed = 0;
      this.waterData = [0, 0, 0];
      this.lariaots = 0;
      this.sia = 0;
      this.powerData[0].value = 0;
      this.powerData[1].value = 0;
      this.powerData[2].value = 0;
      this.powerData[3].value = 0;
      this.PieOneData[0].value = 0;
      this.PieTwoData[0].value = 0;
      this.artotlm = 0;
      this.artotrm = 0;

      this.showPieChart();
      this.showLineChart();
      this.showAngleChart();
      this.showPowerChart();
      this.showRihtChart();
      //
    },
    // 船舶基础信息数据
    digitalShipInfo(shipId) {
      axios({
        url:
          this.$root.BASE_URL + `/work/ship_info/digitalTwin/info?shipId=${shipId}`,
        method: "get",
        headers: {
          authorization: this.token,
        },
      }).then((res) => {
        console.log(res, "船舶基础数据------------");
        if (res.data.code == 200) {
          this.shipInfo = res.data.data;
          let lng = res.data.data.lng;
          let lat = res.data.data.lat;
          this.getWeather(lng, lat);
        } else {
          this.shipInfo = "";
          this.temp = "";
          this.text = "";
          this.windDir = "";
        }
      });
    },
    // 获取天气
    getWeather(lng, lat) {
      axios({
        url: `https://devapi.qweather.com/v7/weather/now?location=${lng},${lat}&key=cfe31ee2ed784df989edc0f18f260e4c`,
        method: "get",
        headers: {
          authorization: this.token,
        },
      }).then(({ data }) => {
        this.temp = data.now.temp;
        this.text = data.now.text;
        this.windDir = data.now.windDir;
      });
    },
    // 图表
    // 左上饼图
    Pie() {
      // 外层虚线圈数据
      let dataArr = [];
      for (var i = 0; i < 150; i++) {
        if (i % 2 === 0) {
          dataArr.push({
            name: (i + 1).toString(),
            value: 50,
            itemStyle: {
              color: "#19A4BB",
              borderWidth: 0,
              borderColor: "rgba(0,0,0,0)",
            },
          });
        } else {
          dataArr.push({
            name: (i + 1).toString(),
            value: 100,
            itemStyle: {
              color: "rgba(0,0,0,0)",
              borderWidth: 0,
              borderColor: "rgba(0,0,0,0)",
            },
          });
        }
      }
      return dataArr;
    },

    showPieChart() {
      let pieChartOne = echarts.init(this.$refs.showPieOne);

      const rate = 0.85;
      let option = {
        // backgroundColor: "#081736",
        polar: {
          radius: ["85%", "90%"],
          center: ["50%", "45%"],
        },
        angleAxis: {
          max: 100,
          clockwise: false,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        radiusAxis: {
          type: "category",
          show: true,
          axisLabel: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            // 水波球
            // value: 50, //  内容 配合formatter
            type: "liquidFill",
            name: "油耗",
            radius: "80%", // 控制中间圆球的尺寸（此处可以理解为距离外圈圆的距离控制）
            center: ["50%", "45%"],
            data: [rate, rate, rate], // data个数代表波浪数
            backgroundStyle: {
              borderWidth: 1,
              color: "rgba(62, 208, 255, 1)", // 球体本景色
            },
            amplitude: "6%", //波浪的振幅
            color: [
              {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 1,
                    color: "#6CDEFC",
                  },
                  {
                    offset: 0,
                    color: "#429BF7",
                  },
                ],
                globalCoord: false,
              },
            ],
            label: {
              formatter: "{a}",
              fontSize: 24,
              color: "#fff",
            },
            outline: {
              show: false,
            },
          },
          {
            // 外层虚线环
            type: "pie",
            zlevel: 0,
            silent: true,
            radius: ["86%", "88%"],
            center: ["50%", "45%"],
            z: 1,
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            data: this.Pie(),
          },
          {
            // 进度条环
            name: "",
            type: "bar",
            roundCap: true,
            z: 2,
            showBackground: false,
            data: [rate * 100],
            coordinateSystem: "polar",
            barWidth: 30, //大的占比环
            itemStyle: {
              opacity: 1,
              color: new echarts.graphic.LinearGradient(0, 0, 1, 1, [
                {
                  offset: 0,
                  color: "#19A4BB",
                },
                {
                  offset: 1,
                  color: "#22C7DA",
                },
              ]),
            },
          },
        ],
      };

      pieChartOne.setOption(option);

      let pieChartTwo = echarts.init(this.$refs.showPieTwo);

      const rateTwo = this.speed / 100;
      console.log(rateTwo, "rateTworateTwo");

      let optionTwo = {
        polar: {
          radius: ["85%", "90%"],
          center: ["50%", "45%"],
        },
        angleAxis: {
          max: 100,
          clockwise: false,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        radiusAxis: {
          type: "category",
          show: true,
          axisLabel: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            // 水波球
            // value: 50, //  内容 配合formatter
            type: "liquidFill",
            name: "船速",
            radius: "80%", // 控制中间圆球的尺寸（此处可以理解为距离外圈圆的距离控制）
            center: ["50%", "45%"],
            data: [rateTwo, rateTwo, rateTwo], // data个数代表波浪数
            backgroundStyle: {
              borderWidth: 1,
              color: "#65fca3", // 球体本景色
            },
            amplitude: "6%", //波浪的振幅
            color: [
              {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 1,
                    color: "#4dfcb8",
                  },
                  {
                    offset: 0,
                    color: "#32e36b",
                  },
                ],
                globalCoord: false,
              },
            ],
            label: {
              formatter: "{a}",
              fontSize: 24,
              color: "#fff",
            },
            outline: {
              show: false,
            },
          },
          {
            // 外层虚线环
            type: "pie",
            zlevel: 0,
            silent: true,
            radius: ["86%", "88%"],
            center: ["50%", "45%"],
            z: 1,
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            data: this.Pie(),
          },
          {
            // 进度条环
            name: "",
            type: "bar",
            roundCap: true,
            z: 2,
            showBackground: false,
            data: [rateTwo * 100],
            coordinateSystem: "polar",
            barWidth: 30, //大的占比环
            itemStyle: {
              opacity: 1,
              color: new echarts.graphic.LinearGradient(0, 0, 1, 1, [
                {
                  offset: 0,
                  color: "#4fec7b",
                },
                {
                  offset: 1,
                  color: "#4dfcb8",
                },
              ]),
            },
          },
        ],
      };

      pieChartTwo.setOption(optionTwo);
    },
    // 左中折线图
    showLineChart() {
      // const data = new Array(4).fill(null).map((item) => {
      //   return {
      //     value: Math.ceil(Math.random() * 600) + 100,
      //   };
      // });
      let LineChart = echarts.init(this.$refs.showLine);
      let option = {
        color: ["#1890FF"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "line", // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter(param) {
            let html = "";
            html += "吃水深度<br>";
            if (param.length > 0) {
              const { value, marker, name } = param[0];
              html += `${marker}${name}:${value}cm`;
            }
            return html;
          },
        },
        grid: {
          top: "15%",
          bottom: "5%",
          left: "3%",
          right: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: ["船尾左吃水", "船尾中轴吃水", "船尾右吃水"],
            boundaryGap: true,
            axisTick: {
              show: true, // 不显示坐标轴刻度线
            },
            splitLine: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#ccc",
              },
            },
            axisLabel: {
              color: "#fff",
              fontSize: 12,
              interval: 0,
              // formatter(val) {
              //   const name = val.length > 3 ? `${val.substr(0, 2)}..` : val;
              //   return name;
              // },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            //y右侧文字
            axisLabel: {
              color: "#fff",
              fontSize: 14,
              show: true,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#ccc",
              },
            },

            // y轴的分割线
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
                color: "rgba(230, 247, 255, 0.20)",
              },
            },
          },
        ],
        series: [
          {
            name: "吃水深度",
            type: "line",
            smooth: true,
            symbol: "none", // 不显示连接点
            tooltip: {
              trigger: "axis",
              axisPointer: {
                // 坐标轴指示器，坐标轴触发有效
                type: "line", // 默认为直线，可选为：'line' | 'shadow'
              },
            },

            lineStyle: {
              width: 3,
              shadowColor: "#1890FF",
              shadowBlur: 20,
            },
            areaStyle: {
              opacity: 1,
              //右下左上
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(24, 144, 255, .5)",
                },
                {
                  offset: 0.3,
                  color: "rgba(24, 144, 255, 0.2)",
                },
                {
                  offset: 1,
                  color: "rgba(24, 144, 255, 0)",
                },
              ]),
            },
            data: this.waterData,
          },
        ],
      };

      LineChart.setOption(option);
    },
    // 左下图
    showAngleChart() {
      let AngleOneChart = echarts.init(this.$refs.showAngleOne);
      let optionOne = {
        series: [
          {
            name: "",
            type: "gauge",
            center: ["50%", "60%"],
            radius: "80%",
            min: 0,
            max: 30,
            startAngle: 180,
            endAngle: 0,
            splitNumber: 2,
            axisLine: {
              lineStyle: {
                // color: [
                //   [0.35, "#ff7f50"],
                //   [1, "#91dff1"],
                // ],
                width: 0,
              },
            },
            splitLine: {
              // 分隔线
              show: true,
              length: -16,
              distance: 10,
              lineStyle: {
                width: 7,
                color: "auto",
              },
            },
            axisTick: {
              // 刻度线样式（及短线样式）
              show: true,
              splitNumber: 7,
              lineStyle: {
                width: 7,
                color: "auto",
              },
              length: -10,
              distance: 10,
            },
            axisLabel: {
              show: false,
              color: "#91dff1",
              fontSize: 22,
              distance: -54,
              formatter: "{value}°",
            },
            detail: {
              fontSize: "20",
              formatter: "{value}°",
              color: "#66d7f1",
              offsetCenter: ["0", "20%"],
            },
            pointer: {
              show: true,
              width: 20,
              length: 30,
              icon: "arrow",
              offsetCenter: [0, "-100%"],
              itemStyle: {
                color: "#66d7f1", // 箭头颜色
                shadowColor: "#66d7f1",
                shadowBlur: 10,
              },
            },
            data: [
              {
                value: this.lariaots,
                name: "船尾左右倾角",
                title: {
                  show: true,
                  color: "#66d7f1",
                  offsetCenter: [0, "-25%"],
                  fontSize: 15,
                },
              },
            ],
          },
        ],
      };
      AngleOneChart.setOption(optionOne);
      let AngleTwoChart = echarts.init(this.$refs.showAngleTwo);
      let optionTwo = {
        series: [
          {
            name: "",
            type: "gauge",
            center: ["50%", "60%"],
            radius: "80%",
            min: 0,
            max: 30,
            startAngle: 180,
            endAngle: 0,
            splitNumber: 2,
            axisLine: {
              lineStyle: {
                // color: [
                //   [0, "#F3EED9"],
                //   [1, "#F3EED9"],
                // ],
                width: 0,
              },
            },
            splitLine: {
              // 分隔线
              show: true,
              length: -16,
              distance: 10,
              lineStyle: {
                width: 7,
                color: "auto",
              },
            },
            axisTick: {
              // 刻度线样式（及短线样式）
              show: true,
              splitNumber: 7,
              lineStyle: {
                width: 7,
                color: "auto",
              },
              length: -10,
              distance: 10,
            },
            axisLabel: {
              show: false,
              color: "#91dff1",
              fontSize: 22,
              distance: -54,
              formatter: "{value}°",
            },
            detail: {
              fontSize: "20",
              formatter: "{value}°",
              color: "#5fed9a",
              offsetCenter: ["0", "20%"],
            },
            pointer: {
              show: true,
              width: 20,
              length: 30,
              icon: "arrow",
              offsetCenter: [0, "-100%"],
              itemStyle: {
                color: "#5fed9a", // 箭头颜色
                shadowColor: "#5fed9a",
                shadowBlur: 10,
              },
            },
            data: [
              {
                value: this.sia,
                name: "船尾前后倾角",
                title: {
                  show: true,
                  color: "#5fed9a",
                  offsetCenter: [0, "-25%"],
                  fontSize: 15,
                },
              },
            ],
          },
        ],
      };
      AngleTwoChart.setOption(optionTwo);
    },
    // 右中柱状图
    showPowerChart() {
      let powerChart = echarts.init(this.$refs.showPower);

      let option = {
        // backgroundColor: "rgba(0, 0, 0, 0.30)",
        dataZoom: [
          {
            type: "slider", // 内置在坐标系中
            height: 0,
            zoomLock: true,
            realtime: true,
            show: false,
            startValue: 0, // 从头开始。
            endValue: 10, // 一次性展示 10个。
          },
        ],
        tooltip: {
          trigger: "axis",
          formatter(param) {
            let html = "";
            html += "油液舱位<br>";
            if (param.length > 0) {
              const { value, marker } = param[0];
              html += `${marker}${value.name}:${value.value}cm`;
            }
            return html;
          },
        },
        grid: {
          top: "15%",
          bottom: "5%",
          left: "5%",
          right: "5%",
          containLabel: true,
        },
        dataset: [
          {
            source: this.powerData,
            dimensions: ["name", "value"],
          },
        ],
        xAxis: [
          {
            type: "category",
            axisLabel: {
              interval: 0,
              color: "#fff",
              fontSize: 14,
              rotate: this.xRotate ? this.xRotate : 0,
              formatter(val) {
                const name = val.length > 3 ? `${val.substr(0, 2)}..` : val;
                return name;
              },
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "rgba(255, 255, 255, 0.4)",
              },
            },
            axisTick: {
              show: false,
            },
            axisPointer: {
              type: "shadow",
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            nameTextStyle: {
              color: "#fff",
              padding: [0, 0, 0, -30],
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "rgba(255, 255, 255, 0.4)",
              },
            },
            axisLabel: {
              interval: 0,
              color: "#fff",
            },
            splitLine: {
              show: false,
              lineStyle: {
                type: "dashed",
                color: "#004B97",
              },
            },
          },
        ],
        series: [
          {
            //柱体
            name: "",
            type: "bar",
            barWidth: 27,
            barGap: "0%",
            itemStyle: {
              normal: {
                color: {
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  type: "linear",
                  global: false,
                  colorStops: [
                    { offset: 1, color: "rgba(47, 160, 255, 1)" },
                    { offset: 0, color: "rgba(47, 160, 255, .1)" },
                  ],
                },
              },
            },
            encode: {
              x: "name",
              y: "value",
            },
          },
          {
            //柱子顶部
            name: "",
            type: "pictorialBar",
            symbolSize: [29, 2],
            symbolOffset: [-1, -6],
            symbolPosition: "end",
            label: {
              show: true,
              position: "top",
              textStyle: {
                fontSize: 10,
                color: "#fff",
              },
            },
            itemStyle: {
              normal: {
                color: "#2FA0FF",
              },
            },
            encode: {
              x: "name",
              y: "value",
            },
          },
        ],
      };
      powerChart.setOption(option);
    },
    // 右下
    showRihtChart() {
      let leftChart = echarts.init(this.$refs.showLeft);

      // 左边
      let option = {
        // backgroundColor: "rgba(0, 0, 0, 0.30)",
        series: [
          {
            center: ["50%", "40%"], //仪表的位置
            name: "刻度", //仪表的名字
            type: "gauge", //统计图类型为仪表
            radius: 75, //统计图的半径大小
            min: 0, //最小刻度
            max: 1000, //最大刻度
            splitNumber: 9, //刻度数量
            startAngle: 225, //开始刻度的角度
            endAngle: -45, //结束刻度的角度
            axisLine: {
              //设置默认刻度盘上的刻度不显示，重新定义刻度盘
              show: false,
              lineStyle: {
                width: 1,
                color: [[1, "rgba(255,255,255,0)"]],
              },
            }, //仪表盘轴线
            axisLabel: {
              //仪表盘上的数据
              show: false,
              color: "#4d5bd1", //仪表盘上的轴线颜色
              distance: 2, //图形与刻度的间距
            }, //刻度标签。
            axisTick: {
              show: true,
              splitNumber: 6, //刻度的段落数
              lineStyle: {
                color: "#429bf7",
                width: 2, //刻度的宽度
                shadowColor: "#429bf7",
                shadowBlur: 2,
              },
              length: 8, //刻度的长度
            }, //刻度样式
            pointer: {
              //表盘上的指针
              show: true,
            },
            dataLabel: {
              show: false,
            },
            itemStyle: {
              color: "#429bf7",
            },
            data: [
              {
                name: "",
                value: this.PieOneData[0].value,
              },
            ],
            splitLine: {
              //文字和刻度的偏移量
              show: true,
              length: 15, //便宜的长度
              lineStyle: {
                color: "#429bf7",
                width: 4,
                shadowColor: "#429bf7",
                shadowBlur: 4,
              },
            }, //分隔线样式
          },
          {
            type: "gauge", //刻度轴表盘
            radius: 186, //刻度盘的大小
            center: ["50%", "40%"], //刻度盘的位置
            splitNumber: 2, //刻度数量
            startAngle: 15, //开始刻度的角度
            endAngle: -45, //结束刻度的角度
            z: 10,
            pointer: {
              //表盘上的指针
              show: false,
            },
            axisLine: {
              //设置默认刻度盘上的刻度不显示，重新定义刻度盘
              show: false,
              lineStyle: {
                width: 1,
                color: [[1, "rgba(255,255,255,0)"]],
              },
            }, //仪表盘轴线
            //分隔线样式。
            splitLine: {
              //表盘上的轴线
              show: false,
            },
            axisLabel: {
              //表盘上的刻度数值文字
              show: false,
            },
            axisTick: {
              //表盘上的刻度线
              show: false,
              splitNumber: 6, //刻度的段落数
              lineStyle: {
                color: "#429bf7",
                width: 2, //刻度的宽度
                shadowBlur: 2,
                shadowColor: "#429bf7",
              },
              length: 8, //刻度的长度
            },
            title: {
              //标题
              show: true,
              offsetCenter: [0, 75], // x, y，单位px
              textStyle: {
                color: "#429bf7",
                fontSize: 15, //表盘上的标题文字大小
                fontWeight: 800,
                fontFamily: "PingFangSC",
              },
            },
            //仪表盘详情，用于显示数据。
            detail: {
              show: false,
              offsetCenter: [0, 100],
              color: "#429bf7",
              formatter: function (value) {
                return value + "转/分";
              },
              textStyle: {
                fontSize: 16,
                color: "#429bf7",
                fontFamily: "PingFangSC",
                fontWeight: 800,
              },
            },
            data: this.PieOneData,
          },
        ],
      };
      leftChart.setOption(option);
      // 右边
      let rightChart = echarts.init(this.$refs.showRight);

      let optionTwo = {
        // backgroundColor: "rgba(0, 0, 0, 0.30)",
        series: [
          {
            center: ["50%", "40%"], //仪表的位置
            name: "刻度", //仪表的名字
            type: "gauge", //统计图类型为仪表
            radius: 75, //统计图的半径大小
            min: 0, //最小刻度
            max: 1000, //最大刻度
            splitNumber: 9, //刻度数量
            startAngle: 225, //开始刻度的角度
            endAngle: -45, //结束刻度的角度
            axisLine: {
              //设置默认刻度盘上的刻度不显示，重新定义刻度盘
              show: false,
              lineStyle: {
                width: 1,
                color: [[1, "rgba(255,255,255,0)"]],
              },
            }, //仪表盘轴线
            axisLabel: {
              //仪表盘上的数据
              show: false,
              color: "#4fec7b", //仪表盘上的轴线颜色
              distance: 2, //图形与刻度的间距
            }, //刻度标签。
            axisTick: {
              show: true,
              splitNumber: 6, //刻度的段落数
              lineStyle: {
                color: "#4fec7b",
                width: 2, //刻度的宽度
                shadowColor: "#4fec7b",
                shadowBlur: 2,
              },
              length: 8, //刻度的长度
            },
            //刻度样式
            pointer: {
              //表盘上的指针
              show: true,
            },
            itemStyle: {
              color: "#4fec7b",
            },

            data: [
              {
                // name: "",
                value: this.PieTwoData[0].value,
              },
            ],
            splitLine: {
              //文字和刻度的偏移量
              show: true,
              length: 15, //便宜的长度
              lineStyle: {
                color: "#4fec7b",
                width: 4,
                shadowColor: "#4fec7b",
                shadowBlur: 4,
              },
            }, //分隔线样式
          },
          {
            type: "gauge", //刻度轴表盘
            radius: 186, //刻度盘的大小
            center: ["50%", "40%"], //刻度盘的位置
            splitNumber: 2, //刻度数量
            startAngle: 15, //开始刻度的角度
            endAngle: -45, //结束刻度的角度
            z: 10,
            pointer: {
              //表盘上的指针
              show: false,
            },
            axisLine: {
              //设置默认刻度盘上的刻度不显示，重新定义刻度盘
              show: false,
              lineStyle: {
                width: 1,
                color: [[1, "rgba(255,255,255,0)"]],
              },
            }, //仪表盘轴线
            //分隔线样式。
            splitLine: {
              //表盘上的轴线
              show: false,
            },
            axisLabel: {
              //表盘上的刻度数值文字
              show: false,
            },
            axisTick: {
              //表盘上的刻度线
              show: false,
              splitNumber: 6, //刻度的段落数
              lineStyle: {
                color: "#4fec7b",
                width: 2, //刻度的宽度
                shadowBlur: 2,
                shadowColor: "#4fec7b",
              },
              length: 8, //刻度的长度
            },
            title: {
              //标题
              show: true,
              offsetCenter: [0, 75], // x, y，单位px
              textStyle: {
                color: "#4fec7b",
                fontSize: 15, //表盘上的标题文字大小
                fontWeight: 800,
                fontFamily: "PingFangSC",
              },
            },
            //仪表盘详情，用于显示数据。
            detail: {
              show: false,
              offsetCenter: [0, 100],
              color: "#4fec7b",
              formatter: function (value) {
                return value + "KM";
              },
              textStyle: {
                fontSize: 16,
                color: "#4fec7b",
                fontFamily: "PingFangSC",
                fontWeight: 800,
              },
            },
            data: this.PieTwoData,
          },
        ],
      };
      rightChart.setOption(optionTwo);
    },
  },
  created() {
    let reg = new RegExp("(^|&)" + "data" + "=([^&]*)(&|$)", "i");
    let r = window.location.search.substr(1).match(reg);
    this.token += decodeURIComponent(r[2]);
    localStorage.setItem("token", this.token);
  },
  mounted() {
    this.initPage();
    window.addEventListener("resize", this.onWindowResize, false);
    this.getCompanyList();
    this.showPieChart();
    this.showLineChart();
    this.showPowerChart();
    this.showAngleChart();
    this.showRihtChart();
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}

#container {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
#container-select {
  position: absolute;
  top: 50px;
  left: 50%;
  transform: translate(-50%);
  z-index: 99;
}
/* .big-content {
  margin-bottom: 5px;
  padding: 5px;

  width: 95%;
  min-height: 30%;
} */
.big-content {
  height: 30%;
}
.left {
  position: absolute;
  left: 0;
  bottom: 0;
  height: 100%;
  z-index: 1;
  /* background-color: #132054; */
  width: 310px;
}
#container-left {
  /* margin: 10px 0; */
  height: 100%;
  border-radius: 10px;
  margin-left: 5px;
  /* border: 2px solid #5592be; */
  /* background-color: aqua; */
  /* border-radius: 10px;
  border: 2px solid #5592be; */
}

.right {
  position: absolute;
  right: 0;
  bottom: 0;
  height: 100%;
  z-index: 1;
  /* background-color: rgba(0, 0, 0, 0.3); */

  /* background-color: #132054; */
  width: 310px;
}
#container-right {
  /* margin: 10px 0; */
  /* height: 100%; */
  height: 100%;
  border-radius: 10px;

  /* border: 2px solid #5592be; */
}
#container-centerRight {
  position: absolute;
  top: 10px;
  right: 330px;
  z-index: 1;
}
#container-centerLeft {
  position: absolute;
  top: 10px;
  left: 330px;
  z-index: 1;
}

#container-centerBottom {
  position: absolute;
  bottom: 0;
  left: 330px;
  z-index: 9;
  width: calc(100% - 330px - 330px);

  height: 30%;
  /* background-color: #132054; */
  /* background-color: rgba(0, 0, 0, 0.3); */
  /* border-bottom: 2px solid red; */
}
.title {
  position: absolute;
  top: 5px;
  left: 50%;
  transform: translate(-50%);
  color: #fff;
  font-size: 28px;
  /* font-weight: 800; */
  letter-spacing: 6px;
}
.title_Top {
  /* width: 300px;
  height: 20px;
  line-height: 20px; */
  color: #fff;
  font-weight: 800;
  padding-left: 10px;
  border-left: 3px solid #e9ce39;
  /* border-bottom: 3px solid #69819d; */
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    #00bbf2 20%,
    rgba(255, 255, 255, 0) 99%
  );
  padding-bottom: 2px;
  width: 200px;
}
.box-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  /* align-content: flex-start; */
  padding: 10px;
  height: 90%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  overflow-y: auto;
}
.box {
  /* 使每个设备状态占据等宽的空间 */
  flex: 0 0 calc(25% - 20px);
  margin: 0 20px 10px 0;
  padding: 10px 0;
  /* height: 48%; */
  background-color: rgba(255, 255, 255, 0.1); /* 轻微的背景色区分 */
  border-radius: 5px;
  border: 1px solid #08ade4;
  box-sizing: border-box;
}
.box:hover {
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.3); /* 悬停时的阴影效果 */
  transition: box-shadow 0.3s ease;
  transform: scale(1);
}
.box-container .box:nth-child(4n) {
  margin-right: 0;
}
.box-container .box:nth-child(4n + 1) {
  margin-left: 10px;
}
.device_title {
  color: #fff;
  padding-bottom: 10px;
  border-bottom: 1px solid #08ade4;
  padding-left: 10px;
}

.device_info {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.device_top {
  color: #42d885;
  font-weight: 600;
  font-size: 20px;
  margin-top: 5px;
}
.device_time {
  color: #42d885;
  margin-top: 10px;
}
::v-deep .el-input__inner {
  border: none;
  background: #0d233b;
  color: #fff;
}

::v-deep .el-cascader .el-cascader-menu {
  /* z-index: 9999; */
}

.cascader {
  width: 290px;
  height: 50px;
  margin-top: 5px;
  margin-left: 8px;
}
.center {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.item_box {
  color: #fff;
}
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;

  transition: 0.3s ease-in-out;
}
</style>
